import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
import axios from "axios";


const initialState = {
    entities: {},
    status: 'idle', // idle loading success fail  
    additionalinfo:{},
    error: null
}
/**
 * 
 * ~~ = ignore
 * ~_~ = delete/set to default value
 */
const PLATFORM = '../../WsWebServicePlatform/'
const WELLSUITE = '../../WsWebServiceWellSuite/';
// Participant/Misc/Types/Get/{AuthToken}/	
// Participant/Misc/Type/Update/{AuthToken}/{ParticipantInteractionGuid}/{InteractionName}/{InteractionDescription}/	
// Participant/Misc/Type/Delete/{AuthToken}/{ParticipantInteractionGuid}/	
// Participant/Misc/Type/Create/{AuthToken}/{InteractionName}/{InteractionDescription}/	
export const recordInteractions = createAsyncThunk('interaction/get', async (incomingVariable, thunkAPI) => {
    
    try {
        const bodies = {"ParamData": {
        "OrganizationGuid": incomingVariable.GroupGuid,
        "AuthToken": incomingVariable.AuthToken,
        "InteractionClassKeyName": incomingVariable.ClassKeyName,
        "InteractionFamilyKeyName": incomingVariable.FamilyKeyName,
        "InteractionTypeKeyName": incomingVariable.TypeKeyName,
        "ComponentGuid": incomingVariable.ComponentGuid
    }}
        //const response = await axios.get(PLATFORM + "InteractionLog/Append/" + incomingVariable.authToken + "/FC116697-AAE7-42E2-A4B2-137899513427"+'/')

        const response = await axios.post(PLATFORM
            + "InteractionLog/Append" , bodies
        )
        const data = await response.data.Success ? response.data : []

        return data
    } catch (err) {
    
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})


const interactionSlice = createSlice({
    name: 'interactions',
    initialState,
    reducers: {        
        interactionClear(state, action) {
            state.entities = initialState
            state.status = "idle"
            
        }
    },
    extraReducers(builder) {
        builder
            //
            .addCase(recordInteractions.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(recordInteractions.fulfilled, (state, action) => {
                state.status = 'idle' 
            })
            .addCase(recordInteractions.rejected, (state, action) => {
                state.error = action.error.message
                state.status = 'fail'
                
            })
            
            
    }
})

export const { interactionClear} = interactionSlice.actions

export default interactionSlice.reducer

export const selectInteractionEntities = (state) => state.interactions.entities

export const selectInteractions = createSelector(selectInteractionEntities, (entities) =>
    Object.values(entities)
)

export const selectInteractionById = (state, InteractionId) => {
    return selectInteractionEntities(state)[InteractionId]
}

